export default __webpack_public_path__ + "static/media/36f8a2e2bc2766196c2487179b7d8d3b1600816697151.1fbefda2.webp";